var map = {
	"./1.png": 437,
	"./2.png": 438,
	"./3.png": 439,
	"./4.png": 440,
	"./5.png": 441,
	"./6.png": 442,
	"./hints/laptop.png": 220,
	"./hints/mobile.png": 221,
	"./hints/stb.png": 222,
	"./hints/tablet.png": 223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;